export function promisifyMethodWithFallback<T, Context>(
    context: Context,
    method: (this: Context, ...args: any[]) => void,
    ...args: any[]
): Promise<T> {
    return new Promise((resolve, reject) => {
        try {
            const mainCallback = (result: T) => {
                resolve(result);
            };

            const errorCallback = (error: string | Error) => {
                const errorMessage = error instanceof Error ? error.message : String(error);
                reject(new Error(errorMessage));
            };

            method.call(context, ...args, mainCallback, errorCallback);
        } catch (error) {
            reject(error);
        }
    });
}

export function promisifyMethod<T, Context>(
    context: Context,
    method: (this: Context, ...args: any[]) => void,
    ...args: any[]
): Promise<T> {
    return new Promise((resolve, reject) => {
        try {
            method.call(context, ...args, resolve);
        } catch (error) {
            reject(error);
        }
    });
}

export function promisifyLoadDataMethodWithTotalCount<T, Context>(
    context: Context,
    method: (this: Context, ...args: any[]) => void,
    ...args: any[]
): Promise<{ data: T; totalCount: number }> {
    return new Promise((resolve, reject) => {
        try {
            method.call(context, ...args, (data: T, totalCount: number) => {
                resolve({ data, totalCount });
            });
        } catch (error) {
            reject(error);
        }
    });
}
